import React from "react"

import Layout from '../components/layout'

const DesignStrategyPage = (props) => (
  <Layout>
    <h2>Coming soon.</h2>
  </Layout>
)

export default DesignStrategyPage
